// COVID Testing default configuration
const defaultCovidConfig = {
  pageMessageNotice: "Please do not use the Airport private testing facility if you suspect you may have COVID-19. If this is the case, you must use NHS testing facilities. Travellers must not use NHS testing facilities for travel related purposes.",
  pageTimeNotice: "<b>Please note: </b>The first available times have been selected for your date. These slots are reserved for the next 5 minutes. Please use the controls below to change the times and the filters to change the test location.",
  vatRate: 0.20,
  labels: {
    selectLocation: "Select Location",
    selectTestType: "Select Test Type",
    confirmProceed: "Confirm & Proceed",
    addCovidTests: "Add Covid Tests: Please select your preferred option below.",
    allTestsPrebook: "All tests must be prebooked and pre-paid:",
    reservingFor: "You are currently reserving for tests on:",
    noSlotsAvailable: "Sorry there are no booking slots available on",
    tryOtherDates: "Try other dates",
    selectTestRequired: "Please select test required.",
    selectVenue: "Select Venue",
    product: "Product",
    selectDate: "Select a date",
    checkAvailability: "Check availability",
    bookCovidTest: "Book your Covid-19 PCR Test."
  },
  explainerText: "All tests are carried out at our drive-through site. The PCR swab is self-administered by the customer and then analysed at the laboratory. There is no clinician available onsite and the test kit will require you to take a sample on a swab which is inserted into the back of the throat and then into one nostril. Results are sent via email the next day - including a Fit to Fly certificate (if the results are negative)."
};

// FastTrack default configuration
const defaultFasttrackConfig = {
  labels: {
    selectVenue: "Select Venue",
    entryDate: "Entry date",
    entryTime: "Entry time",
    adult: "Adult",
    childrenUnder5: "Children under 5",
    infants: "Infants",
    search: "Search"
  },
  noSlotsMessage: "Sorry not available online. Please purchase at the airport.",
  jerNoSlotsMessage: "Sorry, It looks like you're trying to make a request outside of the booking terms. For more details, please check out our FAQs.",
  showFromText: true,
  showTicketsText: true,
  resultsHeadline: "Fasttrack"
};

// Lounge default configuration
const defaultLoungeConfig = {
  labels: {
    selectVenue: "Select Venue",
    entryDate: "Entry date",
    entryTime: "Entry time",
    adult: "Adult",
    under13s: "Under 13's",
    infants: "Infants",
    search: "Search"
  },
  bookingMaxPax: 10,
  resultsHeadline: "Official Airport Lounge",
  adultLabel: "Adults",
  childLabel: "Children",
  infantLabel: "Infants",
  herAdultLabel: "Standard (Ages 6+)",
  herChildLabel: "Child (Ages 0-5)"
};

// Parking default configuration
const defaultParkingConfig = {
  labels: {
    selectVenue: "Select Venue",
    selectStartDate: "Select start date",
    selectStartTime: "Select start time",
    selectEndDate: "Select end date",
    selectEndTime: "Select end time",
    adult: "Adult",
    under13s: "Under 13's",
    selectInfants: "Select Infants",
    search: "Search"
  }
};

// Timer default configuration
const defaultTimerConfig = {
  labels: {
    timeUpTitle: "Sorry... Time is up!",
    timeUpMessage: "The time limit gives others the chance to select appointments. You can try again and we will check if your time slots are still available.",
    tryAgain: "Try Again"
  }
};

// Basket default configuration
const defaultBasketConfig = {
  labels: {
    bookingSummary: "Booking summary",
    basketEmpty: "Your Basket is empty",
    at: "at",
    totalPrice: "Total Price",
    totalDiscountedPrice: "Total Discounted Price",
    confirmProceed: "Confirm & Proceed",
    promoCode: "I have a promo code",
    enterPromoCode: "Enter your promo code below"
  },
  disclaimerText: "All PCR tests are carried out onsite at the test site by the customer and then analysed at the laboratory."
};

// Cross-sell default configuration
const defaultCrossSellConfig = {
  labels: {
    loadingExpressLane: "Loading Express Lane Options",
    expressLaneNotAvailable: "Sorry, Express Lane not available for the moment.",
    loadingLoungeOptions: "Loading Lounge Options",
    loungeNotAvailable: "Sorry, Lounge not available for the moment.",
    from: "From",
    view: "View",
    close: "Close",
    youSearchedFor: "You Searched for:",
    subtotal: "Subtotal",
    addToBasket: "Add to basket"
  }
};

// Cookies default configuration
const defaultCookiesConfig = {
  labels: {
    on: "On",
    off: "Off",
    saveAndClose: "Save and close"
  }
};

// Footer default configuration
const defaultFooterConfig = {
  copyrightEntity: "Airport",
  cookieSettingsText: "Cookie settings",
  poweredByName: "Rezcomm",
  poweredByUrl: "http://www.rezcomm.com/",
  poweredByText: "Powered by Rezcomm"
};

// Footer NWI configuration
const nwiFooterConfig = {
  ...defaultFooterConfig,
  atAirportHeading: "AT THE AIRPORT",
  aboutHeading: "ABOUT",
  informationHeading: "INFORMATION",
  otherHeading: "OTHER",
  viewsHeading: "VIEWS",
  inTheKnowHeading: "IN THE KNOW",
  socialHeading: "SOCIAL",
  copyrightText: "© 2025 Norwich Airport . All Rights Reserved · Norwich Airport, Norwich NR6 6JA - Powered by Rezcomm"
};

// Footer PIT configuration
const pitFooterConfig = {
  ...defaultFooterConfig,
  phoneLabel: "LAZ Parking Offices: 412-472 5050",
  emailAddress: "PIT@lazparking.com",
  address: "1000 Airport blvd, Pittsburgh PA 15231",
  resourcesHeading: "Resources",
  pitAirportHeading: "PIT International Airport",
  alleghenyAirportHeading: "Allegheny County Airport",
  airportAuthorityHeading: "Airport Authority",
  copyrightText: "© 2025 Allegheny County Airport Authority",
  poweredByText: "Powered by Rezcomm"
};

// Header default configuration
const defaultHeaderConfig = {
  basketText: "Basket",
  homeText: "Home",
  realIdMessage: "A REAL ID or other approved ID is now required to fly.",
  realIdUrl: "https://www.dhs.gov/real-id",
  realIdLinkText: "www.dhs.gov/real-id",
  upgradeMessage: "We have upgraded our booking platform. Need Help?",
  upgradeHelpUrl: "https://parking.flylax.com/lax-newbookingsite.html",
  upgradeHelpText: "Click here",
  welcomeText: "Welcome",
  emailDialogTitle: "Please enter your email id to proceed",
  emailAddressLabel: "Enter your email address",
  closeButtonText: "Close",
  proceedButtonText: "Proceed"
};

// Loading default configuration
const defaultLoadingConfig = {
  defaultMessage: "Loading...",
  pleaseWait: "Please wait"
};

// Login default configuration
const defaultLoginConfig = {
  loginTitle: "Login",
  loginInstructions: "Please enter your Login details",
  emailPlaceholder: "email",
  passwordPlaceholder: "password",
  loginButtonText: "Login"
};

// Icons default configuration
const defaultIconsConfig = {
  mapIconAlt: "Map Icon",
  infoIconAlt: "Info Icon"
};

// Modal default configuration
const defaultModalConfig = {
  closeButtonAlt: "Close"
};

// OTP default configuration
const defaultOtpConfig = {
  enterCodeText: "Enter verification code",
  resendCodeText: "Resend code"
};

// Panel default configuration
const defaultPanelConfig = {
  readMoreText: "Read more",
  learnMoreText: "Learn more"
};

// Panels Group default configuration
const defaultPanelsConfig = {
  reasonsHeading: "Reasons to park with us",
  flexibilityTitle: "Flexibility",
  flexibilityDescription: "We allow you to change your reservation up to 2 hours before you fly.",
  noFeesTitle: "No Reservation Fees",
  noFeesDescription: "The price you see is the price you'll pay. Taxes are included in the price you see.",
  sameDayTitle: "Same Day Bookings",
  sameDayDescription: "We've got you covered for those last-minute trips.",
  convenientTitle: "Convenient",
  convenientDescription: "You can't park any closer to the terminal.",
  secureParkingTitle: "Secure parking"
};

// Results default configuration
const defaultResultsConfig = {
  selectText: "Select",
  viewDetailsText: "View Details",
  addToBasketText: "Add to Basket",
  fromText: "From",
  perPersonText: "per person",
  loadingExpressLane: "Loading Express Lane Options",
  expressLaneNotAvailable: "Sorry, Express Lane not available for the moment.",
  viewText: "View",
  closeText: "Close",
  continueText: "Continue",
  continueWithoutExtrasText: "Continue without extras",
  toTerminalText: "To Terminal",
  saveText: "Save",
  unavailableText: "Unavailable",
  bookText: "Book",
  changeSelectionText: "Change Selection",
  cancelText: "Cancel",
  moreInfoText: "More Information",
  infoText: "Info",
  editSearchText: "Edit",
  loadingMessage: "Loading...",
  noSlotsMessage: "Sorry not available online. Please purchase at the airport.",
  nonVisibleMessage: "Bookings less than four hours cannot be completed. Please drive up to the parking facility of your choice and pull a ticket. Thank you.",
  preBookMessage: "",
  defaultResultStyle: "list",
  newResultsType: "standard",
  sortingType: "cheapest",
  resultsHeadline: "Official Airport Parking"
};

export const brandConfigs = {
  // US Brands
  LAX: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'windcave',
    apiEndpoints: 'standard',
    features: {
      sweepstakes: true,
      googleMaps: true,
      bookingForOthers: true,
      evVehicle: true,
      storedVrns: true,
      zeroValue: true
    },
    tcVariant: 'lax',
    links: {
      privacy: 'https://www.flylax.com/privacy',
      terms: 'https://www.flylax.com/terms'
    },
    windcave: {
      successUrl: 'https://laxstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://laxstaging.rezcomm.com/failure.html'
    },
    covidTesting: defaultCovidConfig,
    timezone: 'America/Los_Angeles',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      editSearchText: "Edit Search",
      noSlotsMessage: "Sorry prebooking for more than 30 days stay is not available online. Please drive up to the car park.",
      defaultResultStyle: "grid"
    }
  },
  LAXNEW: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'windcave',
    apiEndpoints: 'standard',
    features: {
      smsOtp: true,
      emailRetryTimer: 30,
      sweepstakes: true,
      googleMaps: true,
      bookingForOthers: true,
      evVehicle: true,
      storedVrns: true,
      zeroValue: true
    },
    tcVariant: 'lax',
    links: {
      privacy: 'https://www.flylax.com/privacy',
      terms: 'https://www.flylax.com/terms'
    },
    covidTesting: defaultCovidConfig,
    timezone: 'America/Los_Angeles'
  },

  RSW: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'windcave',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      airlineManagement: true,
      passengerCount: true,
      shuttleService: true,
      zeroValue: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.flylcpa.com/privacy',
      terms: 'https://www.flylcpa.com/terms'
    },
    timezone: 'US/Eastern'
  },
  OKC: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'windcave',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      evVehicle: true,
      storedVrns: true,
      zeroValue: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.flyokc.com/privacy',
      terms: 'https://www.flyokc.com/terms'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Central',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "okc",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    }
  },
  PIT: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      stripeEmbedded: true,
      zeroValue: true,
      platformMigration: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.flylax.com/privacy',
      terms: 'https://www.flylax.com/terms'
    },
    stripe: {
      successUrl: 'https://pitstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://pitstaging.rezcomm.com/failure.html'
    },
    footerComponent: 'FooterPIT',
    footer: pitFooterConfig,
    timezone: 'US/Eastern',
    searchWidget: {
      showTabs: "parking, fasttrack",
      activeTab: "parking",
      hideTabs: true
    },
    heroText: {
      template: "pit",
      showBorder: true,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      editSearchText: "EDIT RESERVATION",
      loadingMessage: "Fetching parking availability and offers...",
      preBookMessage: "Pre-book early to secure a spot",
      resultsHeadline: "Airport Parking Reservation",
      bookText: "RESERVE NOW",
      sortingType: "price"
    }
  },
  PV1: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'standard',
    features: {
      stripeEmbedded: true,
      bookingForOthers: true,
      dynamicCheckout: true,
      zeroValue: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.pvdairpark.com/privacy',
      terms: 'https://www.pvdairpark.com/terms'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Eastern',
    searchWidget: {
      showTabs: "parking",
      activeTab: "parking",
      hideTabs: true
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      sortingType: "db"
    }
  },

  // Canadian Brands
  YHM: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'moneris',
    apiEndpoints: 'standard',
    features: {
      enhancedEmailValidation: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://flyhamilton.ca/privacy-policy/',
      terms: '/terms.html'
    },
    basketLabel: 'Cart Subtotal',
    reservationErrorMessage: 'Reservations cannot be booked less than 12 hours in advance of arrival at the Airport.',
    timezone: 'US/Eastern',
    results: {
      nonVisibleMessage: "Parking reservations require a minimum duration of 24 hours. Please take a ticket at the parking lot entrance."
    }
  },
  SV1: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'standard',
    features: {
      stripeEmbedded: true,
      zeroValue: true,
      adhocCart: true,
      mobileBasket: true,
      dynamicLists: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://summitairportparking.com/privacy',
      terms: 'https://summitairportparking.com/terms'
    },
    stripe: {
      successUrl: 'https://sv1staging.rezcomm.com/confirmation.html',
      failureUrl: 'https://sv1staging.rezcomm.com/failure.html'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Eastern',
    searchWidget: {
      showTabs: "parking",
      activeTab: "parking",
      hideTabs: true
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      resultsHeadline: "Airport Parking",
      nonVisibleMessage: "Parking reservations require a minimum duration of 24 hours. Please take a ticket at the parking lot entrance."
    }
  },

  // UK Brands
  DEFAULT: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'standard',
    features: {},
    tcVariant: 'standard',
    links: {
      privacy: '/privacy',
      terms: '/terms'
    },
    covidTesting: defaultCovidConfig,
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    }
  },
  LDY: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: true,
      vrnFind: true,
      coachCart: true,
      otpChoice: true,
      multiplePSP: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://cityofderryairport.com/privacy',
      terms: 'https://cityofderryairport.com/terms'
    },
    authipay: {
      successUrl: 'https://ldystaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://ldystaging.rezcomm.com/failure.html'
    },
    footerComponent: 'FooterNWI',
    footer: nwiFooterConfig,
    timezone: 'Europe/London',
    results: {
      nonVisibleMessage: "Not available online. Please contact the City of Derry Airport Customer Services team who will be happy to assist you:<br/>tel: <a href='tel:+442871810784'>+442871810784</a> or <a href='parking@cityofderryairport.com'>parking@cityofderryairport.com.</a>"
    }
  },
  ML1: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'london',
    features: {
      googleMaps: true,
      stripeEmbedded: true,
      zeroValue: true,
      marinaFocus: true,
      dynamicCheckout: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.mdlmarinas.co.uk/privacy',
      terms: 'https://www.mdlmarinas.co.uk/terms'
    },
    stripe: {
      successUrl: 'https://ml1staging.rezcomm.com/confirmation.html',
      failureUrl: 'https://ml1staging.rezcomm.com/failure.html'
    },
    timezone: 'Europe/London',
    results: {
      noSlotsMessage: "No Availability, please contact the Ocean Village team on 02380 229 385",
      resultsHeadline: "Official Ocean Village Car Parking"
    }
  },
  NQY: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      dualOtp: true,
      postcodeFind: true,
      vrnFind: true,
      dynamicCheckout: true,
      alphaValidation: true,
      cardRestrictions: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.cornwallairportnewquay.com/privacy',
      terms: 'https://www.cornwallairportnewquay.com/terms'
    },
    successUrl: 'https://nqystaging.rezcomm.com/confirmation.html',
    failureUrl: 'https://nqystaging.rezcomm.com/failure.html',
    timezone: 'Europe/London',
    results: {
      noSlotsMessage: "Thank you for trying to pre-book your parking.<br/>Unfortunately, there are no pre-book spaces available during your stay.<br/>There will be space when you arrive on-site, and you can pay on exit."
    }
  },
  JER: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'NMI',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: true,
      vrnFind: true,
      googleAddressFinder: true,
      creditBalance: true,
      zeroValue: true,
      travelDetails: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.jerseyairport.com/privacy',
      terms: 'https://www.jerseyairport.com/terms'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking, fasttrack",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    fasttrack: {
      noSlotsMessage: "Sorry, It looks like you're trying to make a request outside of the booking terms. For more details, please check out our FAQs.",
      resultsHeadline: "Jersey Airport Fast Track"
    }
  },
  BHX: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration (No Spaces Please)',
    vrnNotSeperate: true,
    paymentProvider: 'stripe',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true,
      stripeEmbedded: true,
      languages: ['en'],
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.birminghamairport.co.uk/data-protection/privacy-notices/',
      terms: '/terms.html'
    },
    basketLabel: 'Basket Subtotal',
    stripe: {
      successUrl: 'https://prebook.birminghamairport.co.uk/confirmation.html',
      failureUrl: 'https://prebook.birminghamairport.co.uk/failure.html'
    },
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, immigration",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      loadingMessage: "Loading your parking options and deals.. Please wait..",
      resultsHeadline: "Official Onsite Airport Parking",
      sortingType: "db"
    }
  },
  BH2: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration (No Spaces Please)',
    vrnNotSeperate: true,
    paymentProvider: 'stripe',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true,
      stripeEmbedded: true,
      languages: ['en'],
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.birminghamairport.co.uk/data-protection/privacy-notices/',
      terms: '/terms.html'
    },
    basketLabel: 'Basket Subtotal',
    stripe: {
      successUrl: 'https://jet2.prebook.birminghamairport.co.uk/confirmation.html',
      failureUrl: 'https://jet2.prebook.birminghamairport.co.uk/failure.html'
    },
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      loadingMessage: "Loading your parking options and deals.. Please wait..",
      resultsHeadline: "Official Onsite Airport Parking",
      sortingType: "db"
    }
  },
  IP1: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,    
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'evo',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: true,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.iparkglasgow.com/privacy',
      terms: 'https://www.iparkglasgow.com/terms'
    },
    successUrl: 'https://ip1staging.rezcomm.com/confirmation.html',
    failureUrl: 'https://ip1staging.rezcomm.com/failure.html',
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    specialFeatures: {
      googleMapsIframe: true
    },
    results: {
      noSlotsMessage: "It looks like we have no availability for your required dates. Please try a different date or check our FAQs."
    }
  },
  RDU: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'nmi',
    apiEndpoints: 'standard',
    features: {
      collectJS: true,
      googlePay: true,
      applePay: true,
      zeroValue: true
    },
    tcVariant: 'rdu',
    links: {
      privacy: 'https://www.rdu.com/privacy',
      terms: 'https://www.rdu.com/terms'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Eastern',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    specialFeatures: {
      legacyCookies: true
    },
    results: {
      sortingType: "db",
      newResultsType: false
    }
  },
  NWI: {
    currency: '£',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      dualOtp: true,
      postcodeFind: true,
      internationalFocus: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.norwichairport.co.uk/privacy',
      terms: 'https://www.norwichairport.co.uk/terms'
    },
    footerComponent: 'FooterNWI',
    footer: nwiFooterConfig,
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    results: {
      newResultsType: false
    },
    lounge: {
      bookingMaxPax: 6
    }
  },

  BFS: {
    currency: '£',
    phoneCodeOrder: 'IRELAND_FIRST',
    hasCompanyName: false,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: false,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'evo',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy.html',
      terms: '/terms.html'
    },
    successUrl: 'https://bfsstaging.rezcomm.com/confirmation.html',
    failureUrl: 'https://bfsstaging.rezcomm.com/failure.html',
    timezone: 'Europe/London',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    specialFeatures: {
      googleMapsIframe: true
    },
    results: {
      noSlotsMessage: "It looks like we have no availability for your required dates. Please try a different date or check our FAQs."
    }
  },

  // European Brands
  HER: {
    currency: '€',
    phoneCodeOrder: 'CYPRUS_FIRST',
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'jcc',
    apiEndpoints: 'frankfurt',
    features: {
      bilingual: true,
      languages: ['en', 'el'],
      adhocCart: true,
      googleAddressFinder: true,
      alphaValidation: true,
      noBankCards: true
    },
    tcVariant: 'her',
    links: {
      privacy: 'https://www.hermesairports.com/privacy-notice',
      terms: 'https://www.hermesairports.com/terms-and-conditions-of-use'
    },
    timezone: 'Asia/Nicosia',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center",
      heroBackgroundPositionY: "100%"
    },
    results: {
      noSlotsMessage: "Sorry not available online. Please purchase at the airport.",
      nonVisibleMessage: "Parking reservations require a minimum duration of 24 hours. Please take a ticket at the parking lot entrance.",
      newResultsType: false
    },
    lounge: {
      useHerLabels: true
    },
    fasttrack: {
      noSlotsMessage: "Sorry not available online. Please purchase at the airport."
    }
  },
  NOC: {
    currency: '€',
    phoneCodeOrder: 'IRELAND_FIRST',
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'ireland',
    features: {
      dualOtp: true,
      coachCart: true,
      irishCounties: true,
      stripeEmbedded: true,
      zeroValue: true,
      detailedMarketing: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.irelandwestairport.com/privacy',
      terms: 'https://www.irelandwestairport.com/terms'
    },
    stripe: {
      successUrl: 'https://nocstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://nocstaging.rezcomm.com/failure.html'
    },
    footerComponent: 'FooterNWI',
    footer: nwiFooterConfig,
    timezone: 'Europe/London'
  },
  SZG: {
    currency: '€',
    phoneCodeOrder: 'GERMAN_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'frankfurt',
    features: {
      stripeEmbedded: true,
      zeroValue: true,
      dualLanguage: true,
      languages: ['de', 'en'],
      privacyAcceptance: true,
      dynamicCheckout: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.salzburg-airport.com/privacy',
      terms: 'https://www.salzburg-airport.com/terms'
    },
    stripe: {
      successUrl: 'https://szgstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://szgstaging.rezcomm.com/failure.html'
    },
    timezone: 'Europe/Vienna',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "szg",
      showBorder: false,
      alignment: "left"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "left",
      heroTextAlignMobile: "left"
    },
    results: {
      defaultResultStyle: "grid"
    }
  },

  // German Brands
  FM1: {
    currency: '€',
    phoneCodeOrder: 'GERMAN_FIRST',
    hasStateField: true,
    hasTownField: false,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'multiple',
    apiEndpoints: 'frankfurt',
    features: {
      postcodeFind: true,
      vrnFind: true,
      dynamicCheckout: true,
      multiplePSP: true,
      germanDefault: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.memmingen-airport.de/privacy',
      terms: 'https://www.memmingen-airport.de/terms'
    },
    payone: {
      successUrl: 'https://fm1staging.rezcomm.com/confirmation.html',
      failureUrl: 'https://fm1staging.rezcomm.com/failure.html'
    },
    timezone: 'Europe/Berlin',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours",
      activeTab: "tours",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "left"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "left",
      heroTextAlignMobile: "center"
    }
  },
  FMM: {
    currency: '€',
    phoneCodeOrder: 'GERMAN_FIRST',
    defaultCountry: 'DE',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: false,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'payone',
    apiEndpoints: 'frankfurt',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      zeroValue: true,
      germanCompliance: true,
      currencyAfterValue: true,
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.memmingen-airport.de/privacy',
      terms: 'https://www.memmingen-airport.de/terms'
    },
    payone: {
      successUrl: 'https://fmmstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://fmmstaging.rezcomm.com/failure.html'
    },
    timezone: 'Europe/Berlin',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    fasttrack: {
      showFromText: false,
      showTicketsText: false,
      resultsHeadline: "Memmingen Airport Security Fast Track"
    },
    results: {
      resultsHeadline: "Parking directly at Memmingen Airport"
    }
  },
  PB1: {
    currency: '€',
    phoneCodeOrder: 'GERMAN_FIRST',
    defaultCountry: 'DE',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'first',
    apiEndpoints: 'frankfurt',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      zeroValue: true,
      germanCompliance: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://pbw.de/privacy',
      terms: 'https://pbw.de/terms'
    },
    successUrl: 'https://pb1staging.rezcomm.com/confirmation.html',
    failureUrl: 'https://pb1staging.rezcomm.com/failure.html',
    timezone: 'Europe/Berlin',
    results: {
      noSlotsMessage: "Sorry not available online. Please purchase at the car park.",
      nonVisibleMessage: "The selected entry or exit time falls outside our car park operating hours. Please adjust your booking accordingly.",
      resultsHeadline: "PBW Parking"
    }
  },
  NUE: {
    currency: '€',
    phoneCodeOrder: 'GERMAN_FIRST',
    defaultCountry: 'DE',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: false,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'payone',
    apiEndpoints: 'frankfurt',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      zeroValue: true,
      germanCompliance: true,
      currencyAfterValue: true,
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.airport-nuernberg.de/de/datenschutz',
      terms: '/terms.html'
    },
    successUrl: 'https://nuestaging.rezcomm.com/confirmation.html',
    failureUrl: 'https://nuestaging.rezcomm.com/failure.html',
    timezone: 'Europe/Berlin',
    searchWidget: {
      showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours",
      activeTab: "parking",
      hideTabs: false
    },
    heroText: {
      template: "standard",
      showBorder: false,
      alignment: "center"
    },
    styles: {
      fadeTransition: "0.5",
      heroTextAlign: "center",
      heroTextAlignMobile: "center"
    },
    // fasttrack: {
    //   showFromText: false,
    //   showTicketsText: false,
    //   resultsHeadline: "Airport Security Fast Track"
    // },
    results: {
      resultsHeadline: "Parking directly at Nuernberg Airport"
    }
  },

  // Australian Brands
  DRW: {
    currency: '$',
    phoneCodeOrder: 'AUSTRALIA_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'nab',
    apiEndpoints: 'sydney',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      dynamicCheckout: true,
      creditBalance: true,
      zeroValue: true,
      faqSection: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.darwinairport.com.au/privacy',
      terms: 'https://www.darwinairport.com.au/terms'
    },
    nab: {
      successUrl: 'https://drwstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://drwstaging.rezcomm.com/failure.html'
    },
    timezone: 'Australia/Darwin',
    results: {
      sortingType: "db"
    }
  },

  // Additional brands for Results page
  HVN: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      evVehicle: true,
      storedVrns: true,
      zeroValue: true,
      stripeEmbedded: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://parkhvn.com/privacy',
      terms: 'https://parkhvn.com/terms'
    },
    stripe: {
      successUrl: 'https://hvnstaging.rezcomm.com/confirmation.html',
      failureUrl: 'https://hvnstaging.rezcomm.com/failure.html'
    },
    basketLabel: 'Cart Subtotal',
    taxNotice: 'Includes 6.35% state sales tax.',
    timezone: 'US/Eastern',
    brandName: 'Tweed-New Haven Airport',
    results: {
      loadingMessage: "Fetching parking availability and offers...",
      noSlotsMessage: "Parking reservations are sold-out on your travel dates. Drive-up (non-reserved) parking may be available on a first-come-first served basis. Prior to leaving for the airport, check real-time drive-up parking availability <a href='https://parkhvn.com/#top' target='_blank'>here,</a>",
      resultsHeadline: "HVN Reserve"
    }
  },


  ASP: {
    currency: '$',
    phoneCodeOrder: 'AUSTRALIA_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'nab',
    apiEndpoints: 'sydney',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      dynamicCheckout: true,
      creditBalance: true,
      zeroValue: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.adelaideairport.com.au/privacy',
      terms: 'https://www.adelaideairport.com.au/terms'
    },
    timezone: 'Australia/Adelaide',
    results: {
      sortingType: "db"
    }
  },

  SAT: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'windcave',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      evVehicle: true,
      storedVrns: true,
      zeroValue: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.flysanantonio.com/privacy',
      terms: 'https://www.flysanantonio.com/terms'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Central'
  },

  DEN: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'windcave',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      evVehicle: true,
      storedVrns: true,
      zeroValue: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.flydenver.com/privacy',
      terms: 'https://www.flydenver.com/terms'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Mountain'
  },

  GSO: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    defaultCountry: 'US',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'stripe',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      stripeEmbedded: true,      
      evVehicle: true,
      storedVrns: true,
      platformMigration: true,      
      zeroValue: true,
      currencyAfterValue: false,
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy.html',
      terms: '/terms.html'
    },
    stripe: {
      successUrl: 'https://park.flyfrompti.com/confirmation.html',
      failureUrl: 'https://park.flyfrompti.com/failure.html'
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Mountain'
  },

  ST1: {
    currency: '$',
    phoneCodeOrder: 'US_FIRST',
    defaultCountry: 'US',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: false,
    hasCountry: true,
    yourDetailsHeading: 'Contact Details',
    vehicleDetailsHeading: 'Vehicle Details',
    vrnLabel: 'License Plate (no spaces)',
    paymentProvider: 'stripe',
    apiEndpoints: 'standard',
    features: {
      googleMaps: true,
      bookingForOthers: true,
      stripeEmbedded: true,      
      evVehicle: true,
      storedVrns: true,
      platformMigration: true,      
      zeroValue: true,
      currencyAfterValue: false,
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.abm.com/privacy-policy',
      terms: 'https://res.cloudinary.com/rezcomm2018/image/upload/v1787046789/abm/STL_Terms.pdf'
    },
    stripe: {
      successUrl: 'https://parkstl.abmvantage.com/confirmation.html',
      failureUrl: 'https://parkstl.abmvantage.com/failure.html'
    },
    results: {
      resultsHeadline: 'Downtown St. Louis Parking Reservations',
      loadingMessage: "Loading...",
      noSlotsMessage: "Sorry, reservations can be made for durations between 1 hour and 7 days. For parking longer than 7 days, please contact ABM Parking at <a href='mailto:abmparkstl@abm.com' target='_blank'>abmparkstl@abm.com</a> for assistance.",
      nonVisibleMessage: "Bookings longer than 7 days or less than 1 hour cannot be made."
    },
    basketLabel: 'Cart Subtotal',
    timezone: 'US/Mountain'
  },

  AIR: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: true,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy',
      terms: '/terms'
    },
    timezone: 'Europe/London',
    results: {
      newResultsType: "speedy"
    }
  },

  SB1: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: false,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: true,
      dynamicCheckout: true,
      postcodeFind: true,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy',
      terms: '/terms'
    },
    timezone: 'Europe/London',
    results: {
      newResultsType: "speedy"
    }
  },
  SB2: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: false,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://stpancras-highspeed.com/privacy-policy/',
      terms: 'https://www.sabaparking.co.uk/en/payment-services-terms-and-conditions'
    },
    timezone: 'Europe/London',
    results: {
      bookText: "Book Now",
      editSearchText: "EDIT SEARCH",
      defaultResultStyle: "grid",
      resultsHeadline: "Official London St. Pancras Highspeed Parking",
      noSlotsMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
      nonVisibleMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
    },
    basketLabel: 'Booking Subtotal',
  },
  SB3: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: false,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy',
      terms: '/terms'
    },
    timezone: 'Europe/London',
    results: {
      bookText: "Book Now",
      editSearchText: "EDIT SEARCH",
      defaultResultStyle: "grid",
      resultsHeadline: "Official London St. Pancras Highspeed Parking",
      noSlotsMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
      nonVisibleMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
    },
    basketLabel: 'Booking Subtotal',
  },
  SB4: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: false,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy',
      terms: '/terms'
    },
    timezone: 'Europe/London',
    results: {
      bookText: "Book Now",
      editSearchText: "EDIT SEARCH",
      defaultResultStyle: "grid",
      resultsHeadline: "Official London St. Pancras Highspeed Parking",
      noSlotsMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
      nonVisibleMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
    },
    basketLabel: 'Booking Subtotal',
  },
  SB5: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasCompanyName: true,
    hasStateField: false,
    hasTownField: false,
    hasAddressLines: false,
    hasAddressLine_2: false,
    hasTitle: false,
    hasCountry: true,
    vrnLabel: 'Vehicle Registration No Spaces Please',
    paymentProvider: 'nmi',
    apiEndpoints: 'london',
    features: {
      bookingForOthers: false,
      dynamicCheckout: true,
      postcodeFind: false,
      vrnFind: true
    },
    tcVariant: 'standard',
    links: {
      privacy: '/privacy',
      terms: '/terms'
    },
    timezone: 'Europe/London',
    results: {
      bookText: "Book Now",
      editSearchText: "EDIT SEARCH",
      defaultResultStyle: "grid",
      resultsHeadline: "Official London St. Pancras Highspeed Parking",
      noSlotsMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
      nonVisibleMessage: "Parking stays over 30 days cannot be booked online. Please go to the Seasonal Parking tab to view longer-stay options on the homepage.",
    },
    basketLabel: 'Booking Subtotal',
  },
  INV: {
    currency: '£',
    phoneCodeOrder: 'UK_FIRST',
    hasStateField: true,
    hasTownField: true,
    hasAddressLines: true,
    hasAddressLine_2: true,
    hasTitle: true,
    hasCountry: true,
    vrnLabel: 'License Plate (no spaces please)',
    paymentProvider: 'worldpay',
    apiEndpoints: 'london',
    features: {
      dualOtp: true,
      postcodeFind: true,
      vrnFind: true,
      dynamicCheckout: true,
      bookingForOthers: true,
      travelDetails: true
    },
    tcVariant: 'standard',
    links: {
      privacy: 'https://www.hial.co.uk/hial-group/privacy-policies/1',
      terms: 'https://www.hial.co.uk/downloads/file/714/terms-and-conditions'
    },
    timezone: 'Europe/London'
  }
};

export function getBrandConfig(brandCode) {
  const config = brandConfigs[brandCode] || brandConfigs.DEFAULT;
  config.currencyFormat = currencyFormats[config.currency] || currencyFormats['£'];
  
  // Ensure COVID testing config is always available
  if (!config.covidTesting) {
    config.covidTesting = defaultCovidConfig;
  }
  // Ensure FastTrack config is always available
  if (!config.fasttrack) {
    config.fasttrack = defaultFasttrackConfig;
  }
  // Ensure Lounge config is always available
  if (!config.lounge) {
    config.lounge = defaultLoungeConfig;
  }
  // Ensure Parking config is always available
  if (!config.parking) {
    config.parking = defaultParkingConfig;
  }
  // Ensure Timer config is always available
  if (!config.timer) {
    config.timer = defaultTimerConfig;
  }
  // Ensure Basket config is always available
  if (!config.basket) {
    config.basket = defaultBasketConfig;
  }
  // Ensure Cross-sell config is always available
  if (!config.crossSell) {
    config.crossSell = defaultCrossSellConfig;
  }
  // Ensure Cookies config is always available
  if (!config.cookies) {
    config.cookies = defaultCookiesConfig;
  }
  // Ensure Footer config is always available
  if (!config.footer) {
    config.footer = defaultFooterConfig;
  }
  // Ensure Header config is always available
  if (!config.header) {
    config.header = defaultHeaderConfig;
  }
  // Ensure Loading config is always available
  if (!config.loading) {
    config.loading = defaultLoadingConfig;
  }
  // Ensure Login config is always available
  if (!config.login) {
    config.login = defaultLoginConfig;
  }
  // Ensure Icons config is always available
  if (!config.icons) {
    config.icons = defaultIconsConfig;
  }
  // Ensure Modal config is always available
  if (!config.modal) {
    config.modal = defaultModalConfig;
  }
  // Ensure OTP config is always available
  if (!config.otp) {
    config.otp = defaultOtpConfig;
  }
  // Ensure Panel config is always available
  if (!config.panel) {
    config.panel = defaultPanelConfig;
  }
  // Ensure Panels config is always available
  if (!config.panels) {
    config.panels = defaultPanelsConfig;
  }
  // Ensure Results config is always available
  if (!config.results) {
    config.results = defaultResultsConfig;
  }
  return config;
}

// Helper functions for Results page brand logic migration
export function getResultsConfig(brandCode) {
  const config = getBrandConfig(brandCode);
  return config.results || defaultResultsConfig;
}

export function getEditSearchText(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.editSearchText || defaultResultsConfig.editSearchText;
}

export function getLoadingMessage(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.loadingMessage || defaultResultsConfig.loadingMessage;
}

export function getNoSlotsMessage(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.noSlotsMessage || defaultResultsConfig.noSlotsMessage;
}

export function getNonVisibleMessage(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.nonVisibleMessage || defaultResultsConfig.nonVisibleMessage;
}

export function getPreBookMessage(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.preBookMessage || defaultResultsConfig.preBookMessage;
}

export function getDefaultResultStyle(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.defaultResultStyle || defaultResultsConfig.defaultResultStyle;
}

export function getNewResultsType(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.newResultsType !== undefined ? resultsConfig.newResultsType : defaultResultsConfig.newResultsType;
}

export function getSortingType(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.sortingType || defaultResultsConfig.sortingType;
}

export function getResultsHeadline(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.resultsHeadline || defaultResultsConfig.resultsHeadline;
}

export function getBookButtonText(brandCode) {
  const resultsConfig = getResultsConfig(brandCode);
  return resultsConfig.bookText || defaultResultsConfig.bookText;
}

// Helper functions for Index page brand logic migration
export function getSearchWidgetConfig(brandCode) {
  const config = getBrandConfig(brandCode);
  return config.searchWidget || {
    showTabs: "parking, lounge, fasttrack, coach, travel, flights, holidays, hotels",
    activeTab: "parking",
    hideTabs: false
  };
}

export function getHeroTextConfig(brandCode) {
  const config = getBrandConfig(brandCode);
  return config.heroText || {
    template: "standard",
    showBorder: false,
    alignment: "center"
  };
}

export function getStylesConfig(brandCode) {
  const config = getBrandConfig(brandCode);
  return config.styles || {
    fadeTransition: "0.5",
    heroTextAlign: "center",
    heroTextAlignMobile: "center"
  };
}

export function hasSpecialFeature(brandCode, feature) {
  const config = getBrandConfig(brandCode);
  return config.specialFeatures && config.specialFeatures[feature] === true;
}

// Helper functions for Fasttrack page brand logic migration
export function getFasttrackConfig(brandCode) {
  const config = getBrandConfig(brandCode);
  return config.fasttrack || defaultFasttrackConfig;
}

export function getFasttrackNoSlotsMessage(brandCode) {
  const fasttrackConfig = getFasttrackConfig(brandCode);
  return fasttrackConfig.noSlotsMessage || defaultFasttrackConfig.noSlotsMessage;
}

export function shouldShowFromText(brandCode) {
  const fasttrackConfig = getFasttrackConfig(brandCode);
  return fasttrackConfig.showFromText !== false;
}

export function shouldShowTicketsText(brandCode) {
  const fasttrackConfig = getFasttrackConfig(brandCode);
  return fasttrackConfig.showTicketsText !== false;
}

export function getFasttrackResultsHeadline(brandCode) {
  const fasttrackConfig = getFasttrackConfig(brandCode);
  return fasttrackConfig.resultsHeadline || defaultFasttrackConfig.resultsHeadline;
}

// Helper functions for Lounge page brand logic migration
export function getLoungeConfig(brandCode) {
  const config = getBrandConfig(brandCode);
  return config.lounge || defaultLoungeConfig;
}

export function getBookingMaxPax(brandCode) {
  const loungeConfig = getLoungeConfig(brandCode);
  return loungeConfig.bookingMaxPax || defaultLoungeConfig.bookingMaxPax;
}

export function getLoungeResultsHeadline(brandCode) {
  const loungeConfig = getLoungeConfig(brandCode);
  return loungeConfig.resultsHeadline || defaultLoungeConfig.resultsHeadline;
}

export function shouldUseHerLabels(brandCode) {
  const loungeConfig = getLoungeConfig(brandCode);
  return loungeConfig.useHerLabels === true;
}

export function getAdultLabel(brandCode) {
  const loungeConfig = getLoungeConfig(brandCode);
  return shouldUseHerLabels(brandCode) ? loungeConfig.herAdultLabel || defaultLoungeConfig.herAdultLabel : loungeConfig.adultLabel || defaultLoungeConfig.adultLabel;
}

export function getChildLabel(brandCode) {
  const loungeConfig = getLoungeConfig(brandCode);
  return shouldUseHerLabels(brandCode) ? loungeConfig.herChildLabel || defaultLoungeConfig.herChildLabel : loungeConfig.childLabel || defaultLoungeConfig.childLabel;
}

export function getBrandTimeZone(brandCode) {
  const config = getBrandConfig(brandCode);
  const timezoneMap = {
    'RDU': 'US/Eastern',
    'YHM': 'US/Eastern',
    'ST1': 'US/Eastern',
    'HER': 'Asia/Nicosia',
    'NWI': 'Europe/London',
    'AIR': 'Europe/London'
  };
  return config.timezone || timezoneMap[brandCode] || 'Europe/London';
}

export const phoneCodesByOrder = {
  US_FIRST: ['+1', '+44', '+61', '+33', '+49', '+357', '+353'],
  UK_FIRST: ['+44', '+1', '+61', '+33', '+49', '+357', '+353'],
  GERMAN_FIRST: ['+49', '+43', '+44', '+1', '+61', '+33', '+357'],
  CYPRUS_FIRST: ['+357', '+44', '+1', '+61', '+33', '+49', '+353'],
  IRELAND_FIRST: ['+353', '+44', '+1', '+61', '+33', '+49', '+357'],
  AUSTRALIA_FIRST: ['+61', '+44', '+1', '+33', '+49', '+357', '+353']
};

export const paymentUrls = {
  windcave: 'https://securepayservice.rezcomm.com/windcave/session.php',
  stripe: 'https://securepayservice.rezcomm.com/stripe/session.php',
  nmi: 'https://securepaymentdev.rezcommdev.com/nmilivestaging/process.php',
  jcc: 'https://securepaymentdev.rezcommdev.com/jccstaging/initiate.php',
  moneris: 'https://api.rezcomm.com/payment/moneris/checkout/initiate',
  payone: 'https://securepayservice.rezcomm.com/payone/session.php',
  first: 'https://securepayservice.rezcomm.com/first/session.php',
  nab: 'https://securepayservice.rezcomm.com/nab/session.php',
  worldpay: 'https://securepayservice.rezcomm.com/worldpay/session.php'
};

export const apiEndpointMappings = {
  standard: 'VUE_APP_DOMAIN_DEVAWS',
  frankfurt: 'VUE_APP_DOMAIN_DEVAWS_FRA',
  london: 'VUE_APP_DOMAIN_LIVESSO_LDN',
  sydney: 'VUE_APP_DOMAIN_DEVAWS_SYD',
  ireland: 'VUE_APP_DOMAIN_DEVAWS_IRE'
};

export const regionalApiSuffixes = {
  standard: '_nva', // North Virginia (default)
  frankfurt: '_fra', // Frankfurt
  london: '_ldn', // London
  sydney: '_syd', // Sydney
  ireland: '_ire' // Ireland
};

export const currencyFormats = {
  '$': {
    symbol: '$',
    position: 'before',
    decimal: '.'
  },
  '£': {
    symbol: '£',
    position: 'before',
    decimal: '.'
  },
  '€': {
    symbol: '€',
    position: 'after',
    decimal: ','
  }
};

// Brand-specific CSS class helpers
export function getBrandCSSClass(brandCode) {
  return brandCode;
}

export function getBrandStyleVariables(brandCode) {
  const styles = getStylesConfig(brandCode);
  const variables = {
    '--hero-text-align': styles.heroTextAlign,
    '--hero-text-align-mobile': styles.heroTextAlignMobile,
    '--fade-transition': styles.fadeTransition + 's'
  };

  // Brand-specific style overrides
  if (styles.heroBackgroundPositionY) {
    variables['--hero-background-position-y'] = styles.heroBackgroundPositionY;
  }

  return variables;
}
